import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import InstitutionsList from '../containers/InstitutionsList';
import InstitutionDetail from '../containers/InstitutionDetail';
import InstitutionCreateForm from '../containers/InstitutionCreateForm';
import InstitutionUpdateForm from '../containers/InstitutionUpdateForm';
import InstitutionUsage from '../containers/InstitutionUsage';
import NotFound from './common/NotFound';
import Users from '../containers/Users';
import UsersCreated from '../containers/UsersCreated';
import UsersNew from '../containers/UsersNew';
import SelectMonth from '../containers/Check/SelectMonth';
import MoffCheckCreate from '../containers/Check/MoffCheckCreate';
import MoffCheckList from '../containers/Check/MoffCheckList';
import MoffCheck from '../containers/Check/MoffCheckEdit';
import RecordTypeSelectContainer from '../containers/Records/RecordTypeSelectContainer';
import YogaRecordListContainer from '../containers/Records/YogaRecordListContainer';
import YogaRecordCreateContainer from '../containers/Records/YogaRecordCreateContainer';
import YogaRecordEditContainer from '../containers/Records/YogaRecordEditContainer';
import HomeVisitRecordListContainer from '../containers/Records/HomeVisitRecordListContainer';
import HomeVisitRecordCreateContainer from '../containers/Records/HomeVisitRecordCreateContainer';
import HomeVisitRecordEditContainer from '../containers/Records/HomeVisitRecordEditContainer';
import InterestRecordListContainer from '../containers/Records/InterestRecordListContainer';
import InterestRecordCreateContainer from '../containers/Records/InterestRecordCreateContainer';
import InterestRecordEditContainer from '../containers/Records/InterestRecordEditContainer';
import MCIRecordListContainer from '../containers/Records/MCIRecordListContainer';
import MCIRecordCreateContainer from '../containers/Records/MCIRecordCreateContainer';
import MCIRecordEditContainer from '../containers/Records/MCIRecordEditContainer';
import LifeCheckRecordListContainer from '../containers/Records/LifeCheckRecordListContainer';
import LifeCheckRecordCreateContainer from '../containers/Records/LifeCheckRecordCreateContainer';
import LifeCheckRecordEditContainer from '../containers/Records/LifeCheckRecordEditContainer';
import BarthelRecordListContainer from '../containers/Records/BarthelRecordListContainer';
import BarthelRecordCreateContainer from '../containers/Records/BarthelRecordCreateContainer';
import BarthelRecordEditContainer from '../containers/Records/BarthelRecordEditContainer';
import MoffTrainingRecordListContainer from '../containers/Records/MoffTrainingRecordListContainer';
import MoffTrainingRecordCreateContainer from '../containers/Records/MoffTrainingRecordCreateContainer';
import MoffTrainingRecordEditContainer from '../containers/Records/MoffTrainingRecordEditContainer';
import AnalyticsContainer from '../containers/Analytics/AnalyticsContainer';

export default class Routes extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path="/institutions/edit" component={NotFound} />
          <Route path="/institutions/list" component={InstitutionsList} />
          <Route path="/institutions/usage" component={InstitutionUsage} />
          <Route path="/institutions/analytics" component={AnalyticsContainer} />
          <Route path="/institutions/detail" component={InstitutionDetail} />
          <Route path="/institutions/password" component={NotFound} />
          <Route path="/institutions/create" component={InstitutionCreateForm} />
          <Route path="/institutions/update" component={InstitutionUpdateForm} />
          <Route path="/institutions/users/:institution_sub/new" component={UsersNew} />
          <Route path="/institutions/users/:institution_sub/created" component={UsersCreated} />
          <Route path="/institutions/users/:institution_sub" component={Users} />
          <Route
            path="/institutions/:institutionId/users/:userId/records"
            exact
            component={RecordTypeSelectContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/yoga"
            exact
            component={YogaRecordListContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/yoga/create"
            component={YogaRecordCreateContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/yoga/:recordTime"
            component={YogaRecordEditContainer}
          />
          {/* HomeVisit */}
          <Route
            path="/institutions/:institutionId/users/:userId/records/homevisit"
            exact
            component={HomeVisitRecordListContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/homevisit/create"
            component={HomeVisitRecordCreateContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/homevisit/:sequence/edit"
            component={HomeVisitRecordEditContainer}
          />
          {/* Interest */}
          <Route
            path="/institutions/:institutionId/users/:userId/records/interest"
            exact
            component={InterestRecordListContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/interest/create"
            component={InterestRecordCreateContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/interest/:sequence/edit"
            component={InterestRecordEditContainer}
          />
          {/* MCI */}
          <Route
            path="/institutions/:institutionId/users/:userId/records/mci"
            exact
            component={MCIRecordListContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/mci/create"
            component={MCIRecordCreateContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/mci/:timestamp/edit"
            component={MCIRecordEditContainer}
          />
          {/* LifeCheck */}
          <Route
            path="/institutions/:institutionId/users/:userId/records/lifecheck"
            exact
            component={LifeCheckRecordListContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/lifecheck/create"
            component={LifeCheckRecordCreateContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/lifecheck/:sequence/edit"
            component={LifeCheckRecordEditContainer}
          />
          {/* Barthel */}
          <Route
            path="/institutions/:institutionId/users/:userId/records/barthel"
            exact
            component={BarthelRecordListContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/barthel/create"
            component={BarthelRecordCreateContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/barthel/:recordTime/edit"
            component={BarthelRecordEditContainer}
          />
          {/* MoffTraining */}
          <Route
            path="/institutions/:institutionId/users/:userId/records/mofftraining"
            exact
            component={MoffTrainingRecordListContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/mofftraining/create"
            component={MoffTrainingRecordCreateContainer}
          />
          <Route
            path="/institutions/:institutionId/users/:userId/records/mofftraining/:startedAt/edit"
            component={MoffTrainingRecordEditContainer}
          />
          <Route path="/institutions/:institutionId/select_month/:userId" component={SelectMonth} />
          <Route path="/institutions/:institutionId/check/:userId/create" component={MoffCheckCreate} />
          <Route path="/institutions/:institutionId/check/:userId/:selectMonth/:item/:date" component={MoffCheck} />
          <Route path="/institutions/:institutionId/check/:userId/:selectMonth" component={MoffCheckList} />
        </Switch>
      </div>
    );
  }
}
